import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import "./Management6.css";

import { FaTrash, FaSave, FaEdit } from "react-icons/fa";
import ProcurementTable from "./ProcurementTable";
import ProcurementCart from "./ProcurementCart";
import axios from "axios";
import Foodadinginveotry from "./Foodadinginveotry";
import ChefInventory from "./ChefInventory";
const Management6 = () => {
  const [activeTab, setActiveTab] = useState("Raw Material");
  // const [editModes, setEditModes] = useState({});
  const fileInputRef = useRef(null);
  const [editModes, setEditModes] = useState([]);


  const [data1, setData1] = useState([]);
  useEffect(() => {
    // Assume data1 is your table data coming from API
    setEditModes(data1.map(() => false)); // all rows are read-only by default
  }, [data1]);






  const tabContent = {
    "Raw Material": <Foodadinginveotry />,

    "Chef Table": <ChefInventory />,
    Procurement: <ProcurementTable />,
    "Procurement Cart": <ProcurementCart />,
  };

  return (
    <div
      style={{
        overflowY: "auto",
        height: "550px",
        marginTop: "30px",
        scrollbarWidth: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap", // allow buttons to wrap on small screens
          gap: "10px",
          justifyContent: "center", // center horizontally
          marginBottom: "15px",
        }}
      >
        {Object.keys(tabContent).map((label) => (
          <button
            key={label}
            onClick={() => setActiveTab(label)}
            style={{
              border: "none",
              borderRadius: "10px",
              width: "130px",
              height: "40px",
              backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
              color: "#000",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              flex: "1 1 120px", // flexible width, minimum 120px
            }}
          >
            {label}
          </button>
        ))}
      </div>

      <div style={{ borderRadius: "8px" }}>
        {tabContent[activeTab]}
      </div>
    </div>
  );
};

// Styles


export default Management6;
